export const color = {
  gray: {
    dark: "#69696F",
    base: "#B2BABF",
    light: "#E6EBEE",
    lightest: "#F6F6F6",
  },
  error: { base: "#EF4242", hover: "#ed3333" },
  success: { base: "#6EBE44", hover: "#579935" },
  body: { base: "#ffffff" },
  base: { base: "#002856" },
  black: { base: "#4A4A4B" },
};

export const font = {
  family: {
    base: "Source Sans Pro, sans-serif",
    head: "Montserrat",
  },
  base: "16px",
  small: "14px",
  xsmall: "12px",
  large: "18px",
  xlarge: "20px",
  xxlarge: "22px",
  xxxlarge: "24px",
};

export const theme = {
  inkassier: {
    primary: {
      base: "#FF8300",
      hover: "#ff6e00",
    },
    secondary: {
      base: "#6EBE44",
      hover: "#579935",
    },
    tertiary: {
      base: "#002856",
      hover: "#002044",
    },
    quaternary: {
      base: "#2071AD",
      hover: "#195a8a",
    },
    border: {
      base: "#D6DAE0",
      hover: "#002856",
    },
    font: {
      base: "Source Sans Pro, sans-serif",
      head: "Montserrat",
    },
    text: {
      base: "#002856",
      light: "#002856",
      dark: "#002856",
    },
    link: {
      base: "#FF8300",
      hover: "#cc6800",
    },
    ideal: {
      base: "#FF8300",
      hover: "#ff6e00",
    },
    gray: {
      dark: "#69696F",
      base: "#e6ebee",
      light: "#E7EBF0",
    },
  },
  invoned: {
    primary: {
      base: "#F29706",
      hover: "#F29706",
    },
    secondary: {
      base: "#F29706",
      hover: "#F29706",
    },
    tertiary: {
      base: "#59256B",
      hover: "#601E6F",
    },
    accent: {
      base: "#e5e5fd",
    },
    quaternary: {
      base: "#2071AD",
      hover: "#195a8a",
    },
    border: {
      base: "#D6DAE0",
      hover: "#59256B",
    },
    font: {
      base: "Plus Jakarta Sans",
      head: "Prometo Webfont",
    },
    text: {
      base: "#600B6F",
      light: "#826A8C",
      dark: "#2E063F",
    },
    link: {
      base: "#826A8C",
      hover: "#600B6F",
    },
    ideal: {
      base: "#F29706",
      hover: "#F29706",
    },
    gray: {
      dark: "#69696F",
      base: "#E7EBF0",
      light: "#E6EBEE",
    },
  },
};
